<template>
    <UiModal :is-open="showModal" @close="closeModal" modal-class="co-venture-popup overflow-hidden">
        <template #content>
            <div class="flex flex-col sm:flex-row items-stretch">
                <!-- Image - Top on mobile, Left on desktop -->
                <div class="w-full sm:w-1/2 h-40 sm:h-auto">
                    <img
                        :src="`${cdnUrl}/uploads/marketing/c1vb-popup.jpg`"
                        alt="Capital One Venture Business Card"
                        class="w-full h-full object-cover object-center block"
                    />
                </div>

                <!-- Offer Details - Below on mobile, Right on desktop -->
                <div class="w-full sm:w-1/2 text-left px-6 py-6 sm:py-8">
                    <h3 class="text-center mb-5">
                        <span class="text-2xl font-extrabold text-orange">
                            Limited Time Offer on the New Capital One Venture
                            Business Card
                        </span>
                    </h3>

                    <!-- Card Art -->
                    <img
                        v-if="cardImageUrl"
                        :src="`${cdnUrl}/${cardImageUrl}`"
                        alt="Capital One Venture Business"
                        class="w-full max-w-[220px] mx-auto mb-5 block"
                    />

                    <p class="mb-6 text-base">
                        Earn <strong>75,000 miles</strong> once you spend
                        $7,500 in the first 3 months on the New Capital One
                        Venture Business Card, and an additional
                        <strong>75,000 miles</strong> once you spend $30,000
                        in the first 6 months.
                    </p>

                    <!-- CTA Button -->
                    <div class="text-center pb-4">
                        <a
                            :href="ctaUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="btn btn-orange !ml-0 !text-md"
                            @click="closeModal"
                        >
                            Learn More
                            <i class="fa-light fa-arrow-right ml-2"></i>
                        </a>
                    </div>

                    <p class="text-center text-xs text-gray-400 dark:text-slate-400 mt-2">
                        Partner Offer. Terms Apply.
                    </p>
                </div>
            </div>
        </template>
    </UiModal>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import UiModal from '@/components/ui/modal/ui-modal.vue';

const props = defineProps({
    eligible: { type: Boolean, default: false },
    dismissedAt: { type: String, default: null },
    campaignActive: { type: Boolean, default: false },
    ctaUrl: { type: String, required: true },
    dismissUrl: { type: String, required: true },
    cardImageUrl: { type: String, default: null },
});

const showModal = ref(false);
const cdnUrl = computed(() => window.cdnUrl);

const visible = computed(
    () => props.eligible && !props.dismissedAt && props.campaignActive
);

// Fire-and-forget axios POST. The endpoint returns 204 No Content; using
// Inertia's router.post here would cause Inertia to interpret the 204 as
// an empty page response and render a blank dialog overlay (visible bug).
// Pattern matches markTravelPlusStepSeen() in TourManager.vue.
const closeModal = () => {
    showModal.value = false;
    axios.post(props.dismissUrl).catch(() => {
        // Best-effort: if the dismissal POST fails, the modal stays
        // closed for this session and will reappear on next page load.
    });
};

onMounted(() => {
    if (visible.value) {
        showModal.value = true;
    }
});
</script>
